import React, { Component } from 'react'
import styled from 'styled-components';
import media from '../stylesheets/media';
import _ from 'lodash';
import { COLUMN_WIDTH } from '../constants/defaults';

const Link = styled.a`
  display:block;
  padding: 32px;
  /* border-bottom: 1px solid black; */
  max-width: ${COLUMN_WIDTH};


  ${media.mobileLarge`
    padding: 10px 15px;
    max-width: inherit;
    width: calc(100% - 30px);
  `}


  &:hover {
    opacity: 1;
  }


  &:last-child {
    border-bottom: none;
  }
  h4 {
    margin-top: 10px;
    margin-bottom: 0;
  }


  ${media.mobileLarge`
    padding: 10px 15px;
  `}
`;

const TruncateDiv = styled.div`
  margin-bottom: 24px;
`;

const FullImg = styled.img`
  width: 100%;
`;

class CustomWorkThumb extends Component {
  render() {
    let firstParagraph = this.props.heading;
    let customPhoto = _.first(this.props.custom_work_photos);

    // Helper function to determine file type
    const renderMedia = (file) => {
      if (!file) return null;
      const ext = file.split('.').pop().toLowerCase();
      if (["mp4", "webm", "ogg"].includes(ext)) {
        return (
          <video width="100%" controls>
            <source src={file} type={`video/${ext}`} />
            Your browser does not support the video tag.
          </video>
        );
      } else if (["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(ext)) {
        return <FullImg src={file} alt="" />;
      } else {
        return null;
      }
    };

    return (
      <Link href={`/custom-work/${this.props.id}`}>
        {customPhoto ? renderMedia(customPhoto.file) : null}
        <h4>
          {this.props.title}
        </h4>
        <TruncateDiv dangerouslySetInnerHTML={{ __html: firstParagraph }} />
      </Link>
    )
  }
}

export default CustomWorkThumb;
